import React from 'react';
import { Text } from 'rebass';
import styled from 'styled-components';
import colors from '../theme/colors';

const StyledText = styled(Text)`
  text-transform: capitalize;
  max-width: 700px;
`;

const ErrorMessage: React.FC<any> = ({ children }): JSX.Element => (
  <StyledText
    as="span"
    color={colors.primary2}
    textAlign="center"
    fontSize="18px"
    fontWeight={700}
    marginBottom="20px"
  >
    {children}
  </StyledText>
);

export default ErrorMessage;
